import { StyledTableRow, StyledTableCell } from "./StyledTable";

export function EmptyTableState({ colSpan = 1 }) {
  return (
    <StyledTableRow className="no-dat-found-box">
      <StyledTableCell colSpan={colSpan} style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={require("../../assets/images/no-data.svg").default}
            alt="No data"
          />
          <h3 className="text-center text-light">
            No records found.
          </h3>
        </div>
      </StyledTableCell>
    </StyledTableRow>
  );
}
